export const tr = {
    'NumberDefectIds.MUST_BE_NOT_OLDER': 'Farklı bir dönem seçip tekrar deneyin',
    'NumberDefectIds.MUST_BE_NOT_OLDER-TITLE': 'İstatistikler gösterilemiyor',
    bannerAimingFailed: 'Hata oluştu. Az sonra hedeflemeyi tekrar deneyin.',
    bannerAimingSuccessful: 'Hedefleme başarıyla yapıldı. Reklamı görüntülemek için 10 dakikanız var.',
    'cancel-survey': 'Brand Lift araştırmasını iptal etmek istediğinize emin misiniz?',
    'client-campaigns': 'Müşteri kampanyaları',
    'could-not-cancel-survey': 'Araştırma iptali sırasında hata oluştu',
    'failed-to-update-data': 'Veriler güncellenemedi. Önceki değerler gösteriliyor.',
    'fetch-moderation-reject-reasons-error': 'Ret nedenleri alınamadı. Lütfen, tekrar deneyin.',
    'link-message-groups': 'Görüntüle',
    'mass-actions-server-error': 'Hata oluştu. Lütfen, sayfayı tekrar yükleyin.',
    'my-campaigns': 'Kampanyalarım',
    operationError: 'Kopyalama sırasında hata oluştu',
    'phrase-1': 'sözcük grubu',
    'phrase-2': 'sözcük grubu',
    'phrase-5': 'sözcük grubu',
    'popup-save-success': 'Değişiklikler kaydedildi',
    'search-and-replace-success':
        'Toplam {selectedCount} sözcük grubundan {updatedTotalCount} adedinde değişiklik yapıldı'
};
